import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_CASH_BALANCE_PORTFOLIO = gql`
  query GetCashBalancePortfolio {
    getCashBalancePortfolio {
      totalAmount
      formattedAmount
      transitAmount
      balance
    }
  }
`;

const GET_CASH_BALANCE_BACKUP = gql`
  query GetCashBalanceBackup {
    getCashBalanceBackup {
      totalAmount
      formattedAmount
      transitAmount
      balance
    }
  }
`;

export const useGetCashBalanceWithFallback = () => {
  return useFetchCallback(GET_CASH_BALANCE_PORTFOLIO, GET_CASH_BALANCE_BACKUP);
};
